
import { IDilutorBathFilter } from "../models/filters/dilutorBathFilter";
import { IParameter } from "../models/parameter";
import { API_CENTRE } from "./config";
import _o2sService from "./_o2sServices";
import { IFilter } from "../models/filters/filter";
import { IDilutorBathForm } from "../models/forms/dilutorBathForm";
import { IDilutorBathPDTO } from "../models/dtos/dilutorBathPDTO";
import { apiCallWithAuth } from "../helper/apiManager";
import { IDataOperationResult } from "../models/api/dataOperationResult";
import { ServiceOperationResult } from "../models/api/serviceOperationResult";


export default class DilutorBathService extends _o2sService {

    protected static override mainUrl:string = API_CENTRE + "/api/v1/dilutorbaths";

    protected static override  getUrlFilter<F extends IDilutorBathFilter>(filter?: F):string {
        let url = super.getUrlFilter(filter as IFilter);
        if ( filter != null)
        {    
            if(filter.powderTypeId != undefined)
                url += `&PowerTypeId=${filter.powderTypeId}`;

            if(filter.centerId != undefined)
                url += `&CenterId=${filter.centerId}`;
        }
        
        return url;
    }

    static async UnusedBaths(id: number, isCheck: boolean, filter: IDilutorBathFilter) {
        try {

            var url = "";

            if(filter.include != undefined)
                url += `?Include=${filter.include}`;
            else {      
                url += "?Include=*";
            }            
            url += `&PageNumber=${filter.page}&PageSize=${filter.pageSize}`;
            url += `&isCheck=${isCheck}`;

            if ( filter.search != undefined )
                url += `&GlobalSearch=${filter.search}`;
            if ( filter.sort != undefined )
                url += `&Sort=${filter.sort}`;
            if ( filter.id != undefined )
                url += `&Id=${filter.id}`;
            if(filter.centerId != undefined)
                url += `&CenterId=${filter.centerId}`;
            

          const { data } = await apiCallWithAuth(this.mainUrl + `/unusedBath/${id}` + url,"put");
    
          return {
            err: false,
            data: data,
          };
        } catch (err) {
          return {
            err: true,
            data: err,
          };
        }
      }

    public static async getAllPowderTypes():Promise<ServiceOperationResult<IParameter[]|IDataOperationResult<IParameter>>> {
        const url = this.mainUrl +"/powdertypes";
        try {
            let result = await apiCallWithAuth(url, "get");
            return this.ReturnListObject<IParameter>(result);
        } catch (err:any) {
            return this.ReturnError(err);
        }
    }

    protected static override toDTO(obj:IDilutorBathForm):IDilutorBathPDTO {
        const dto = super.toDTO(obj) as IDilutorBathPDTO;
        return dto;
    }
}